export default __webpack_public_path__ + "static/media/brandon.ff3f1546.jpeg";